import { render } from "./assessment-v1.vue?vue&type=template&id=08931e35&scoped=true"
import script from "./assessment-v1.vue?vue&type=script&lang=js"
export * from "./assessment-v1.vue?vue&type=script&lang=js"

import "./assessment-v1.vue?vue&type=style&index=0&id=08931e35&lang=sass&scoped=true"

import exportComponent from "../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08931e35"]])

export default __exports__